import { render, staticRenderFns } from "./ServiceOrderActivity.vue?vue&type=template&id=0850999c&scoped=true"
import script from "./ServiceOrderActivity.vue?vue&type=script&lang=js"
export * from "./ServiceOrderActivity.vue?vue&type=script&lang=js"
import style0 from "./ServiceOrderActivity.vue?vue&type=style&index=0&id=0850999c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0850999c",
  null
  
)

export default component.exports